/**
 *
 * ActivedirForm
 *
 */

import React, { Component } from 'react';
import store from '../../../../redux/store';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { DetailHeader, InputField, SelectField } from 'cx-ui-components';
import DetailWrapper from '../../../../components/DetailWrapper';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const WrappedDetailHeader = styled(DetailHeader)`
  margin-left: 35px;
`;

export default class ActivedirForm extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.readContactLayouts();
  }

  render() {
    const isDisabled = this.props.isSaving || this.props.inherited;
    const layouts = this.props.contactLayouts
      ? this.props.contactLayouts.map((l) => ({ label: l.name, value: l.id }))
      : [];

    return (
      <Wrapper>
        <DetailWrapper open data-automation="activedirPropertiesAzure">
          <WrappedDetailHeader text="Azure access" />
          <InputField
            name="properties.azureTenantId"
            label="Azure Tenant Id *"
            componentType="input"
            inputType="text"
            data-automation="integrationsActivedirAzureTenantId"
            disabled={isDisabled}
          />
          <InputField
            name="properties.applicationId"
            label="Application Id *"
            componentType="input"
            inputType="text"
            data-automation="integrationsActivedirApplicationId"
            disabled={isDisabled}
          />
          <InputField
            name="properties.secret"
            label="Secret *"
            componentType="input"
            inputType="text"
            type="password"
            data-automation="integrationsActivedirSecret"
            disabled={isDisabled}
          />
        </DetailWrapper>
        <DetailWrapper open data-automation="activedirPropertiesImport">
          <WrappedDetailHeader text="Import options" />
          <InputField
            name="properties.externalSource"
            label="External source"
            componentType="input"
            inputType="text"
            data-automation="integrationsActivedirExternalSource"
            disabled={true}
          />
          <InputField
            name="properties.groupsFilter"
            label="Groups Filter"
            componentType="input"
            inputType="text"
            data-automation="integrationsActivedirGroupsFilter"
            disabled={isDisabled}
          />
          <InputField
            name="properties.locationsFilter"
            label="Locations Filter"
            componentType="input"
            inputType="text"
            data-automation="integrationsActivedirLocationsFilter"
            disabled={isDisabled}
          />
        </DetailWrapper>
        <DetailWrapper open data-automation="activedirDetailWrapperClientOptions">
          <WrappedDetailHeader text="Client options" />
          <SelectField
            name="properties.layoutId"
            label="Contacts layout"
            options={layouts}
            data-automation="integrationsLayoutType"
            disabled={isDisabled}
          />
        </DetailWrapper>
      </Wrapper>
    );
  }
}

ActivedirForm.propTypes = {
  isSaving: PropTypes.bool,
  inherited: PropTypes.bool,
  userHasUpdatePermission: PropTypes.bool,
  sidePanelUpdatePermissions: PropTypes.object,
  contactLayouts: PropTypes.array,
  readContactLayouts: PropTypes.func,
};
